// extracted by mini-css-extract-plugin
module.exports = {"statusWrapper":"BackupTargetList_statusWrapper-2bNuv","status":"BackupTargetList_status-V14P8"};